import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

import { Divider } from '../../../shared/components/Divider';
import { Text } from '../../../shared/components/Text';

const useStyle = makeStyles(theme => ({
  textStyle: {
    fontFamily: 'SofiaProBold',
    letterSpacing: 10,
    paddingLeft: 60,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      padding: '0px 0px 30px 0',
    },
  },
  flexContainer: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  textContainer: {
    width: '10%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },

  carouselContainer: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      width: 300,
      height: 300,
      paddingTop: 30,
      margin: 'auto',
    },
  },

  image: {
    width: props => (props.size === 'big' ? 370 : '100%'),
    height: props => (props.size === 'big' ? 360 : 250),
    backgroundSize: 'cover',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      width: props => (props.size === 'big' ? 370 : 200),
      height: props => (props.size === 'big' ? 360 : 200),
    },
  },

  overlayTextContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    transition: '.5s ease',
    backgroundColor: theme.palette.black,
    '&:hover': {
      opacity: '0.7',
    },
    [theme.breakpoints.down('md')]: {
      '&:hover': {
        opacity: '0.7',
      },
    },
  },
  overlayTextStyle: {
    padding: '20px 10px',
    color: 'white',
    fontFamily: 'SofiaProLight',
    fontSize: 16,
  },
}));

export const Person = ({ size, bio, image, name, job, position }) => {
  const styles = useStyle({ size });

  return (
    <Box style={{ width: '100%' }}>
      <Box
        className={styles.image}
        style={{
          backgroundImage: `url(${image})`,
          backgroundPosition: position,
        }}
      >
        {size === 'big' && (
          <Box className={styles.overlayTextContainer}>
            <Text variant="body1" className={styles.overlayTextStyle}>
              {bio}
            </Text>
          </Box>
        )}
      </Box>
      <Divider height={10} />
      <Box>
        <Text labelColor="primary" variant="h5">
          {name}
        </Text>
        <Text variant="subtitle2">{job}</Text>
      </Box>
      <Divider height={30} />
    </Box>
  );
};

Person.defaultProps = {
  size: 'small',
  bio: '',
  position: null,
};

Person.propTypes = {
  size: PropTypes.oneOf('big', 'small'),
  bio: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  image: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  job: PropTypes.string.isRequired,
  position: PropTypes.string,
};
